import './scripts/main';
import './scripts/forms';
import { createSwiper } from './scripts/swipers';
import { isTablet, setupResponsiveCallback } from './scripts/utils';

let teamSwiper = null;

function setupTeamContainer() {
  const $container = $('#team-swiper');
  const $wrapper = $('#team-swiper-wrapper');

  $container.toggleClass('swiper-container', isTablet());
  $wrapper.toggleClass('swiper-wrapper', isTablet());
  $container.find('.team-member').toggleClass('swiper-slide', isTablet());

  if (isTablet()) {
    if (!teamSwiper) {
      teamSwiper = createSwiper(
        '#team-swiper',
        {
          spaceBetween: 40,
          breakpoints: {
            768: { slidesPerView: 2 },
            900: { slidesPerView: 3 },
          },
        }
      );
    }
  } else {
    if (teamSwiper !== null) {
      teamSwiper.destroy();
      teamSwiper = null;
    }
  }
}

setupResponsiveCallback(setupTeamContainer);
